module.exports = __webpack_public_path__ + "static/media/botanical-rising-ierZlNiWba0-unsplash.db099700.jpg";